import { defineComponent as _defineComponent } from 'vue'
import type { LoungePassTraveller } from '../../../types.ts';

interface Props {
  loungePassTraveller?: LoungePassTraveller;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'lounge-pass-additional-traveller-card',
  props: {
    loungePassTraveller: { default: () => ({} as LoungePassTraveller) }
  },
  setup(__props: any) {

const props = __props as { loungePassTraveller: LoungePassTraveller };

//types


return { __sfc: true,props }
}

})